
import React from 'react';
import { useThemeData } from '../hooks/ThemeData';
import CreateGlobalStyle from './global';
import {Helmet} from 'react-helmet';
import { usePlatformData } from '../hooks/Platform';

const GlobalTheme : React.FC = () => {
    const {theme} = useThemeData();
    const {platform} = usePlatformData();

    return <> 
    <Helmet>
        <title>{platform?.eventName || 'Plataforma Online'}</title>
    </Helmet>
    <CreateGlobalStyle {...theme} />
    
    </>;
}

export default GlobalTheme;